import React from "react";

import SvgIcon from "@material-ui/core/SvgIcon";

interface IProps {
  className?: string;
}

const CustomRaceIcon = (props: IProps) => {
  const { className } = props;

  return (
    <SvgIcon className={className} viewBox="6 8 27 27">
      <g xmlns="http://www.w3.org/2000/svg" fill="currentColor">
        <g>
          <g>
            <rect x="3.8" y="14.7" width="2.6" height="2.6" />
          </g>
          <g>
            <rect x="3.8" y="20.4" width="2.6" height="2.6" />
          </g>
          <g>
            <rect x="3.8" y="26" width="2.6" height="2.6" />
          </g>
          <g>
            <path d="M25.2,20.4C25.2,20.4,25.2,20.4,25.2,20.4L8,20.4V23h14.6L25.2,20.4z" />
          </g>
          <g>
            <path d="M25.8,17.3c0-0.1,0-0.2,0-0.3c0.1-0.7,0.2-1.3,0.4-1.9l0-0.1c0-0.1,0.1-0.1,0.1-0.2H8v2.6L25.8,17.3     C25.8,17.3,25.8,17.3,25.8,17.3z" />
          </g>
          <g>
            <path d="M18.3,27.3c0.1-0.1,0.1-0.2,0.2-0.3l1.1-1.1H8v2.6h9L18.3,27.3L18.3,27.3z" />
          </g>
        </g>
        <path d="M39.5,15l-3.6,3.6c-0.4,0.4-1,0.4-1.4,0l-1.6-1.6c-0.4-0.4-0.4-1,0-1.4l3.6-3.6c-2.4-1.2-5.4-0.8-7.4,1.2   c-1.9,1.9-2.3,4.6-1.5,6.9l-8,8c-1,1-1,2.7,0,3.7c1,1,2.7,1,3.7,0l7.9-7.9c2.3,0.9,5.1,0.4,7-1.5C40.3,20.5,40.7,17.5,39.5,15z    M22.2,30.7l-1,0.2c-0.2,0-0.4-0.1-0.4-0.3l-0.1-0.8c0-0.2,0.1-0.4,0.3-0.5l1-0.2c0.2,0,0.4,0.1,0.4,0.3l0.1,0.8   C22.5,30.5,22.4,30.7,22.2,30.7z" />
      </g>
    </SvgIcon>
  );
};

export default CustomRaceIcon;
